import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateClient } from 'api/clients/use-update-client.ts';
import type { ClientRes, UpdateClientReq } from 'api/swagger';
import { UserRole, useRoleGuard } from 'shared/hooks/use-role-guard.ts';
import type { IClientFormFields } from 'components/clients/client-form';
import { ClientForm } from 'components/clients/client-form';
import {
  FormDrawerWithButton,
  EFormDrawerSize,
  EFormDrawerWithButtonIconType,
} from 'components/common/form-drawer-with-button';

interface IEditClientProps {
  client: ClientRes;
}

export const EditClient: React.FC<IEditClientProps> = (props) => {
  const { client } = props;
  const { t } = useTranslation();

  const isAllow = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.customer_manager]);

  const { mutateAsync: updateClient, isLoading } = useUpdateClient(client.id);

  const handleFinish = async (value: IClientFormFields) => {
    const apiVariables: UpdateClientReq = {
      ...value,
      postCountryId: value.postCountryId ?? null,
    };
    await updateClient(apiVariables);
  };

  if (!isAllow) return null;

  return (
    <FormDrawerWithButton
      formComponent={ClientForm}
      formProps={{ initialValues: client as IClientFormFields }}
      title={t('client:edit_client')}
      buttonLabel={t('client:edit_client')}
      iconType={EFormDrawerWithButtonIconType.EDIT}
      size={EFormDrawerSize.MIDDLE}
      isLoading={isLoading}
      onFinish={handleFinish}
    />
  );
};
